import {
  Rotationsplan_AbteilungsleiterByStandortIdsAndArbeitsbereichIdQuery,
  Rotationsplan_AbteilungsleiterByStandortIdsAndArbeitsbereichIdQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { useMemo } from 'react';
import { Abteilungsleiter } from '@/domain/mitarbeiter/features/rotationsplan/entities/Abteilungsleiter';
import { ABTEILUNGSLEITER_BY_STANDORT_IDS_AND_ARBEITSBEREICH_ID } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useAbteilungsleiter/graphql/queries';

export function useAbteilungsleiter(
  standortIds: string[],
  arbeitsbereichId: string | undefined,
): {
  abteilungsleiter: Abteilungsleiter[];
  error?: string;
} {
  const result = useSuspenseQuery<
    Rotationsplan_AbteilungsleiterByStandortIdsAndArbeitsbereichIdQuery,
    Rotationsplan_AbteilungsleiterByStandortIdsAndArbeitsbereichIdQueryVariables
  >(ABTEILUNGSLEITER_BY_STANDORT_IDS_AND_ARBEITSBEREICH_ID, {
    variables: { standortIds, arbeitsbereichId },
  });

  const abteilungsleiter = useMemo(
    () =>
      result.data.mitarbeiter_abteilungsleiterByStandortIdsAndArbeitsbereichId.map(
        (abteilungsleiter) =>
          new Abteilungsleiter({
            id: abteilungsleiter.id,
            vorname: abteilungsleiter.vorname,
            nachname: abteilungsleiter.nachname,
          }),
      ) ?? [],
    [result.data],
  );

  if (result.error) {
    Sentry.captureException(result.error);
    return { abteilungsleiter: [] };
  }

  return { abteilungsleiter };
}
